namespace $.$$ {
	export class $shm_hitalama_map_widget_float_application extends $.$shm_hitalama_map_widget_float_application {
		@ $mol_mem
		definition() {
			const definition = this.widget().Type_custom()?.remote()
			if( !definition ) throw new Error( 'Приложение не найдено в каталоге.' )
			return definition
		}

		@ $mol_mem_key
		source_text( kind: string ) {
			return kind === 'default' ? this.widget().code() : this.definition().source_text( kind as $shm_hitalama_map_widget_entity_custom_source_kind )
		}

		@ $mol_mem
		application_context() {
			return this.map().runtime().context_rich({
				[ '$' + 'this_widget' ]: this.widget(),
				[ '$' + 'page' ]: this.Map_page(),
				[ '$' + 'view' ]: this,
			})
		}

		application_content() {
			const result = this.model().result_for( 'default' )
			return result ? [ result.component ] : []
		}
	}
}
